<script>
import BTableSimple from './BTableSimple.vue'
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/Roadmaps/Directions/BaseEvents/BaseEventCriteria/table-headers'


export default {
  name: 'BTableBaseEventFiles',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
